<div class="px-3 py-1 rounded-2xl border-solid border-gray-light border-2 font-semibold" *ngIf="user">
  <span class="platinum" *ngIf="user.subscription_plan == SubscriptionPlanEnum.PLATINUM" translate>Platynowy</span>
  <span class="gold" *ngIf="user.subscription_plan == SubscriptionPlanEnum.GOLD" translate>Złoty</span>
  <span class="silver" *ngIf="user.subscription_plan == SubscriptionPlanEnum.SILVER" translate>Srebny</span>
</div>
